"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.default = {
    e400: {
        title: "This page is not working.",
        subTitle: "The browser sent a request that the server does not understand.",
        btn: "Go Back",
    },
    e403: {
        title: "You do not have permission to view this page",
        subTitle: "Use the menu to visit other pages, or contact your systems administrator to request permission",
        btn: "Go to Home",
    },
    e404: {
        title: "Whoops! We can't seem to find that",
        subTitle: (React.createElement(React.Fragment, null,
            "The page you're trying to reach does not exist :(. Check the address and try again or report an error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "Go Back",
    },
    e405: {
        title: "Whoops! There is an error with your request",
        subTitle: (React.createElement(React.Fragment, null,
            "Check if you are sending valid data and try again. If you are still having difficults, you can report this error to ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "",
    },
    e408: {
        title: "This request cannot be completed because it reached a timeout with our servers",
        subTitle: (React.createElement(React.Fragment, null,
            "Check your wifi or local network connection and try again. If you are still having difficults, you can report this error to ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "",
    },
    e500: {
        title: "There's a problem loading this page",
        subTitle: (React.createElement(React.Fragment, null,
            "There\u2019s a technical problem with the app that has prevented this page from loading. Unsaved information may be lost. Try reloading this page or going to another page in the app. If that doesn\u2019t work, contact",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            " for updates and try again later.")),
        btn: "Reload page",
    },
    e599: {
        title: "This page cannot be displayed because the internet connection was lost",
        subTitle: "Check your wifi or local network connection and reload the page",
        btn: "Reload page",
    },
    custom: {
        title: "Oops! Something is wrong with your request. Check the error and try again.",
        subTitle: "",
        btn: "",
    },
};
//# sourceMappingURL=en.js.map